import { render, staticRenderFns } from "./domainname.vue?vue&type=template&id=5bebb9e2&scoped=true"
import script from "./domainname.vue?vue&type=script&lang=js"
export * from "./domainname.vue?vue&type=script&lang=js"
import style0 from "./domainname.vue?vue&type=style&index=0&id=5bebb9e2&prod&lang=scss&scoped=true"
import style1 from "./domainname.vue?vue&type=style&index=1&id=5bebb9e2&prod&lang=css"
import style2 from "./domainname.vue?vue&type=style&index=2&id=5bebb9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebb9e2",
  null
  
)

export default component.exports